/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voucher_TitleInputs */

const en_voucher_title = /** @type {(inputs: Voucher_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redeem a voucher`)
};

const id_voucher_title = /** @type {(inputs: Voucher_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tukar voucher`)
};

/**
* | output |
* | --- |
* | "Redeem a voucher" |
*
* @param {Voucher_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const voucher_title = /** @type {((inputs?: Voucher_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voucher_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_voucher_title(inputs)
	return en_voucher_title(inputs)
});